import { isDev, isStaging } from './env.utils';

export function testId(name?: string) {
  if (isStaging() || (isDev() && name)) {
    return {
      'data-testid': name,
    };
  }
}
